import App from '@/app/App.vue'
import { i18n } from '@/app/I18n'
import { router, Vue } from '@/app/Vue'
import store from '@/store/store'
import type { Theme } from '@/types/ThemeOptions'
import initializeThemeVariables from '../helpers/Themes'

export type BreakpointType = 'all' | 'mobile' | 'desktop'

export function createVueApp() {
  return new Vue({
    el: '#app',
    router,
    i18n,
    store,

    watch: {
      $route: {
        immediate: true,
        handler(to, from) {
          // Sets body classes based on route name.
          // TODO Namespace dynamic class names. e.g. `route-{$name}`
          // TODO Do not use forward slashes in route names.
          if (from?.name) {
            document.body.classList.remove(...from.name.split('/'))
          }

          if (to?.name) {
            document.body.classList.add(...to.name.split('/'))
          }
        },
      },
    },

    render: (h) => h(App),

    methods: {
      switchTheme(theme: Theme) {
        // TODO Is an empty tenant config good enough for now?
        initializeThemeVariables({}, theme)
      },
    },
  })
}
